import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { getVirtualToursData } from '../../services/VirtualTours.js';
import GeneralVirtualTours from './GeneralVirtualTour.js';
import VirtualTour from './VirtualTour.js';
import MyTabsNested from '../../components/MyTabsNested.js';

const EditVirtualTourRecord = () => {

  const { alias } = useParams();
  const [virtualTourTitle, setVirtualTourTitle] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralVirtualTours, subTabs: [
        { id: "basic", title: "Basic", Component: VirtualTour }
      ]
    }
  ], []);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/virtual-tours/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getVirtualToursData(alias);

          if (result) {
            setVirtualTourTitle(result?.data?.[0]?.name || result?.data?.[0]?.masterlist_alias);
          }
        }
      } catch (error) {
        console.error('Error fetching Flip Book data:', error);
      }
    };

    getBasicData();
  }, [alias]);

  return (
    <Stack py="5px">
      <Box px="4" pb="4">
        <Text fontSize={"22px"} fontWeight={"600"}>{_.capitalize(virtualTourTitle)}</Text>
      </Box>
      <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/virtual-tours"} />
    </Stack>
  );
};

export default EditVirtualTourRecord;